import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AnonymizationLevelOptions from '../AnonymizationLevelOptions';

import {
	Form,
	FormHeader,
	FormTitle,
	FormDescription,
	Notice,
} from '../styles';

export class AnonymizationLevelForm extends Component {
	static propTypes = {
		exportedMetadata: PropTypes.object.isRequired,
		onChange: PropTypes.func.isRequired,
		clearStaleState: PropTypes.func.isRequired,
	};

	componentWillUnmount() {
		this.props.clearStaleState();
	}

	render() {
		const { exportedMetadata, onChange } = this.props;

		return (
			<Form>
				<FormHeader>
					<FormTitle>Anonymization level</FormTitle>
					<FormDescription>
						<p>
							We must only store data as per the agreement in the Engagement
							Letter for your specific client engagement. Please select which
							statement you see in your Engagement Letter.
						</p>
						<Notice>
							If you select the incorrect option you will personally place
							AlixPartners in breach of contract.
						</Notice>
					</FormDescription>
				</FormHeader>
				<AnonymizationLevelOptions
					data={exportedMetadata.anonymizationLevel}
					onChange={onChange}
				/>
			</Form>
		);
	}
}
